import type { Stage, ApplicationStageActions } from '../../shared/types';
import { createAppliedStageConfig } from './applied';
import { createClosedStageConfig } from './closed';
import { createEvaluatingStageConfig } from './evaluating';
import { createOfferStageConfig } from './offer';
import { createQualifiedStageConfig } from './qualified';
import { createRejectedStageConfig } from './rejected';
import { createWithdrawnStageConfig } from './withdrawn';
import type { ApplicationStageConfig, CreateApplicationStageConfig } from './types';

export type { ApplicationStageConfig } from './types';
export { hasRejectionDecision } from './shared';

const STAGE_CONFIG_FACTORIES: Record<Stage, CreateApplicationStageConfig> = {
  Applied: createAppliedStageConfig,
  Evaluating: createEvaluatingStageConfig,
  Qualified: createQualifiedStageConfig,
  Offer: createOfferStageConfig,
  Rejected: createRejectedStageConfig,
  Withdrawn: createWithdrawnStageConfig,
  Closed: createClosedStageConfig,
};

export const getApplicationStageConfig = (stage: Stage, actions: ApplicationStageActions): ApplicationStageConfig =>
  STAGE_CONFIG_FACTORIES[stage](actions);
